import type { FC } from 'react';

import { Space } from '@sravni/react-design-system';
import { Sheet } from '@sravni/react-design-system/lib/Sheet';
import { Text, Heading } from '@sravni/react-design-system/lib/Typography';

import { OptimizedPicture } from '@src/components/ui/OptimizedPicture';
import { ToFullDealAdvertisingButton } from 'features/FullDeal';
import { FULL_DEAL_MOBILE_APP_LINKS, FULL_DEAL_MOBILE_APP_SOURCE } from 'features/FullDeal/config';

import firstImage from './assets/appSheetFirstImage.png';
import fourthImage from './assets/appSheetFourthImage.png';
import secondImage from './assets/appSheetSecondImage.png';
import thirdImage from './assets/appSheetThirdImage.png';
import topImage from './assets/mobileAppSheet.png';
import styles from './MobileAppConvenienceSheet.module.scss';
import { MobileAppConvenienceSheetTexts } from './MobileAppConvenienceSheet.texts';

const leftColumnCards = [
  {
    text: MobileAppConvenienceSheetTexts.questionnaire,
    image: (
      <OptimizedPicture
        imgClassName={styles.firstImage}
        className={styles.imageContainer}
        img={firstImage}
        alt={MobileAppConvenienceSheetTexts.questionnaire}
      />
    ),
  },
  {
    text: MobileAppConvenienceSheetTexts.products,
    image: (
      <OptimizedPicture
        imgClassName={styles.secondImage}
        className={styles.imageContainer}
        img={secondImage}
        alt={MobileAppConvenienceSheetTexts.products}
      />
    ),
  },
];

const rightColumnCards = [
  {
    text: MobileAppConvenienceSheetTexts.status,
    image: (
      <OptimizedPicture
        imgClassName={styles.thirdImage}
        className={styles.imageContainer}
        img={thirdImage}
        alt={MobileAppConvenienceSheetTexts.status}
      />
    ),
  },
  {
    text: MobileAppConvenienceSheetTexts.reminder,
    image: (
      <OptimizedPicture
        imgClassName={styles.fourthImage}
        className={styles.imageContainer}
        img={fourthImage}
        alt={MobileAppConvenienceSheetTexts.reminder}
      />
    ),
  },
];

const renderCard = ({ text, image }: { text: string; image: React.ReactNode }) => (
  <div key={text} className={styles.card}>
    <Text size={14}>{text}</Text>
    {image}
  </div>
);

type MobileAppConvenienceSheetProps = {
  visible: boolean;
  onClose: (event: React.MouseEvent | KeyboardEvent | PopStateEvent) => void;
};

export const MobileAppConvenienceSheet: FC<MobileAppConvenienceSheetProps> = ({ visible, onClose }) => (
  <Sheet visible={visible} onClose={onClose}>
    <Sheet.Header
      title={
        <Space size={[16, 16]} direction="vertical" align="center">
          <OptimizedPicture
            className={styles.topImageContainer}
            imgClassName={styles.topImage}
            img={topImage}
            alt={MobileAppConvenienceSheetTexts.title}
          />
          <Heading level={2} className={styles.title}>
            {MobileAppConvenienceSheetTexts.title}
          </Heading>
        </Space>
      }
      className={styles.header}
    />
    <Sheet.Content className={styles.content}>
      <div className={styles.grid}>
        <div className={styles.column}>{leftColumnCards.map(renderCard)}</div>
        <div className={styles.column}>{rightColumnCards.map(renderCard)}</div>
      </div>
    </Sheet.Content>
    <Sheet.Footer className={styles.footer}>
      <ToFullDealAdvertisingButton
        size={52}
        block
        variant="primary"
        color="dark"
        link={FULL_DEAL_MOBILE_APP_LINKS.FROM_REFERAL_VITRINA}
        source={FULL_DEAL_MOBILE_APP_SOURCE.FROM_CALCULATOR_BOTTOM_SHEET}
      >
        {MobileAppConvenienceSheetTexts.continueInApp}
      </ToFullDealAdvertisingButton>
    </Sheet.Footer>
  </Sheet>
);
